"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventTypeNameToIndices = exports.ONE_MINUTE = exports.ONE_SECOND = void 0;
const types_1 = require("./network/modules/types");
exports.ONE_SECOND = 1000;
exports.ONE_MINUTE = 60 * exports.ONE_SECOND;
exports.eventTypeNameToIndices = {
    [types_1.EventType.send]: [6, 0],
    [types_1.EventType.accountCreate]: [9, 0],
    [types_1.EventType.accountSetDescription]: [9, 1],
    [types_1.EventType.accountAddRoles]: [9, 2],
    [types_1.EventType.accountRemoveRoles]: [9, 3],
    [types_1.EventType.accountDisable]: [9, 4],
    [types_1.EventType.accountAddFeatures]: [9, 5],
    [types_1.EventType.accountMultisigSubmit]: [9, [1, 0]],
    [types_1.EventType.accountMultisigApprove]: [9, [1, 1]],
    [types_1.EventType.accountMultisigRevoke]: [9, [1, 2]],
    [types_1.EventType.accountMultisigExecute]: [9, [1, 3]],
    [types_1.EventType.accountMultisigWithdraw]: [9, [1, 4]],
    [types_1.EventType.accountMultisigSetDefaults]: [9, [1, 5]],
    [types_1.EventType.accountMultisigExpired]: [9, [1, 6]],
    [types_1.EventType.mint]: [12, 0],
    [types_1.EventType.burn]: [12, 1],
};
